<template>
  <div class="cover-page">
    <div class="cover-page-head">
      <el-input
        v-model="searchData.shopName"
        placeholder="请输入商户名称"
        clearable
        @clear="getTableList"
        width="200px"
        class="search-input"
      ></el-input>
      <el-button type="primary" size="mini" @click="getTableList"
        >搜索</el-button
      >
      <el-button
        class="operation-btn"
        type="primary"
        size="mini"
        @click="reCreate"
        >重新生成</el-button
      >
      <el-button type="primary" size="mini" @click="reset">清空</el-button>
    </div>
    <el-table
      v-loading="loading"
      :data="tableList"
      highlight-current-row
      style="width: 100%"
      max-height="400"
    >
      <!-- <el-table-column type="index" label="序号" width="80" align="center" /> -->
      <el-table-column type="sort" label="序号" width="80" align="center">
        <template slot-scope="scope">
          <div class="merchant-name">
            <span class="name">{{ scope.row.sort }}</span>
            <span v-if="scope.row.id">
              <i
                class="el-icon-edit"
                style="margin-left: 10px"
                @click="handleClickSort(scope.row)"
              ></i>
            </span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="商户名称" align="center" width="400">
        <template slot-scope="scope">
          <div class="merchant-name">
            <p class="name">{{ scope.row.merchantName }}</p>
            <div>
              <i
                class="el-icon-edit"
                style="margin-right: 10px"
                @click="handleClick(scope.row)"
              ></i>
              <i
                v-if="scope.row.merchantName"
                class="el-icon-delete"
                @click="onDelete(scope.row)"
              ></i>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="shopName" label="店铺名" align="center" />
      <el-table-column label="店铺logo" align="center">
        <template slot-scope="scope">
          <img
            v-if="scope.row.shopLogo"
            :src="scope.row.shopLogo"
            alt=""
            style="width: 60px; height: 60px"
          />
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-show="page.total > 0"
      :total="page.total"
      :page-sizes="page.pageSizes"
      :page.sync="page.current"
      :limit.sync="page.size"
      @pagination="getTableList"
    />
    <!-- 新增/编辑 -->
    <el-dialog
      title="选择推荐店铺"
      :visible.sync="dialogVisible"
      width="450px"
      @close="onClose"
      append-to-body
    >
      <ShopAutocomplete ref="shopRef" @handleSelect="handleSelect" />
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="onClose">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit"
          >确认</el-button
        >
      </span>
    </el-dialog>
    <setSort ref="setSort" @refreshList="getStoreList" />
  </div>
</template>
<script>
/** 首页推荐-店铺补位设置*/
import {
  getRecommendShopCoverList,
  regenerateRecommendShop,
  emptyRecommendShopCoverList,
  addRecommendShop,
  updateRecommendShop,
  deleteRecommendShop,
} from "@/api/recommendationHome";
import Pagination from "@/components/Pagination";
import ShopAutocomplete from "./shopAutocomplete";
import { MessageBox } from "element-ui";
import setSort from "../components/setSort";

export default {
  name: "StoreCoverStore",
  components: {
    Pagination,
    ShopAutocomplete,
    setSort,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.tableList = [];
        this.getTableList();
      }
    },
  },
  data() {
    return {
      searchData: {},
      tableList: [],
      loading: false,
      dialogVisible: false,
      currentInfo: {},
      showCoveStore: false,
      page: {
        current: 1,
        size: 10,
        total: 0,
        pageSizes: [10, 20, 30, 50],
      },
    };
  },
  mounted() {
    this.getTableList();
  },
  methods: {
    handleClickSort(row) {
      console.log(row);
      this.$refs.setSort.show(row, "shop");
    },
    getStoreList() {
      this.dialogVisible = false;
      this.getTableList();
    },
    // 修改店铺排序

    async getTableList() {
      this.loading = true;
      const { data } = await getRecommendShopCoverList({
        keyWords: this.searchData.shopName || "",
        current: this.page.current,
        size: this.page.size,
        complementFlag: 1, //是否补位商品
      }).finally(() => (this.loading = false));
      const { records, total } = data;
      records && (this.tableList = [...records]);
      this.page.total = total ?? 0;
    },

    reset() {
      MessageBox.confirm("是否清空补位数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await emptyRecommendShopCoverList();
        res && this.$message.success("清空成功");
        res && this.getTableList();
      });
    },
    /**重新生成 */
    async reCreate() {
      // this.getTableList()
      MessageBox.confirm("是否重新生成补位数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await regenerateRecommendShop();
        res && this.$message.success("重新生成成功");
        res && this.getTableList();
      });
    },
    /**返回  */
    goBack() {
      this.$emit("close");
    },
    handleSelect(row) {
      this.tableData = [];
      this.currentInfo.shopId = row.id;
    },
    handleClick(row) {
      this.dialogVisible = true;
      this.currentInfo = row;
    },
    // 新增推荐商铺信息
    onAdd(shopId) {
      addRecommendShop({ shopId: shopId }).then((res) => {
        if (res.code === 0) {
          this.$message.success("操作成功");
          this.getTableList();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    // 编辑推荐商铺信息
    onEdit(row) {
      updateRecommendShop({ shopId: row.shopId, id: row.id }).then((res) => {
        if (res.code === 0) {
          this.$message.success("操作成功");
          this.getTableList();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    onDelete(row) {
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return deleteRecommendShop(row.id);
        })
        .then(() => {
          this.getTableList();
          this.$message.success("删除成功");
        });
    },
    onSubmit() {
      this.dialogVisible = false;
      const { currentInfo } = this;
      if (currentInfo.id) {
        this.onEdit(currentInfo);
        return;
      }
      this.onAdd(currentInfo.shopId);
    },

    onClose() {
      this.dialogVisible = false;
      this.$refs.shopRef.params.keyWords = "";
    },
  },
};
</script>
<style lang="scss" scoped>
.cover-page {
  &-head {
    display: flex;
    margin-bottom: 15px;
    .search-input {
      width: 200px;
      margin-right: 10px;
    }
    .operation-btn {
      margin-left: 80px;
    }
  }
}
</style>
